const cssVariables = {
  ":root": {
    "--header-height": "6vh",
    "--page-margin-y": "1.5rem",
    "--page-margin-x": "1.5rem",
  },
};

export default cssVariables;
